import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/workspaces.svg
 */
const IconWorkspaces: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12.302 19.486a2.248 2.248 0 011.904 1.7 8.389 8.389 0 002.72-1.122 2.26 2.26 0 01.17-2.55l-2.175-2.176a4.46 4.46 0 01-2.619 1.054v3.094zm1.973 2.278a2.25 2.25 0 01-2.278 2.244 2.293 2.293 0 01-2.279-2.244 9.584 9.584 0 01-2.991-1.224 2.353 2.353 0 01-1.598.611 2.271 2.271 0 01-2.28-2.244 2.388 2.388 0 01.644-1.598c-.576-.936-1-1.958-1.258-3.026A2.266 2.266 0 01.67 10.407a2.368 2.368 0 011.564-.68 10.584 10.584 0 011.258-2.992 2.387 2.387 0 01-.643-1.598 2.277 2.277 0 012.279-2.278 2.388 2.388 0 011.598.644 10.498 10.498 0 012.991-1.259A2.316 2.316 0 0111.997 0a2.273 2.273 0 012.278 2.244c1.069.256 2.09.68 3.026 1.259a2.288 2.288 0 013.196.033 2.316 2.316 0 01.034 3.196c.574.92.988 1.933 1.225 2.992a2.296 2.296 0 012.081 3.147 2.248 2.248 0 01-2.081 1.41 9.445 9.445 0 01-1.225 3.025 2.289 2.289 0 01-.034 3.197 2.316 2.316 0 01-3.196.034 9.457 9.457 0 01-3.026 1.227zm-4.489-.578a2.291 2.291 0 011.938-1.7v-3.094a4.294 4.294 0 01-2.618-1.054L6.93 17.514a2.2 2.2 0 01.136 2.55c.84.52 1.759.899 2.72 1.122zm4.42-18.362a2.285 2.285 0 01-1.904 1.735v3.06a4.525 4.525 0 012.619 1.088l2.175-2.175a2.317 2.317 0 01-.17-2.585 9.204 9.204 0 00-2.72-1.123zM11.724 4.56a2.328 2.328 0 01-1.938-1.735 10.02 10.02 0 00-2.72 1.123 2.254 2.254 0 01-.136 2.585l2.176 2.175a4.324 4.324 0 012.618-1.088v-3.06zm5.78 12.547a2.26 2.26 0 012.55-.17 8.344 8.344 0 001.123-2.72 2.25 2.25 0 01-1.7-1.904h-3.095a4.852 4.852 0 01-.305 1.393c-.196.439-.448.85-.749 1.225l2.176 2.176zM6.522 6.94a2.25 2.25 0 01-2.584.128 9.976 9.976 0 00-1.122 2.72 2.327 2.327 0 011.733 1.94h3.062A4.648 4.648 0 018.698 9.11L6.522 6.94zm0 10.165l2.176-2.176a4.537 4.537 0 01-1.087-2.618H4.549a2.286 2.286 0 01-1.733 1.904c.122.487.281.964.476 1.427.18.447.395.88.644 1.293a2.316 2.316 0 012.586.17zM17.504 6.94l-2.176 2.175a4.276 4.276 0 011.054 2.62h3.095a2.292 2.292 0 011.7-1.94 8.993 8.993 0 00-1.122-2.72 2.197 2.197 0 01-2.548-.137l-.003.002z"
      fill="currentColor"
    />
  </svg>
);

export default IconWorkspaces;
